import { ResolveFn } from '@angular/router';
import { mensagem } from '../../services/api-mensagens.service';

export const mensagemPendenteResolver: ResolveFn<mensagem | null> = () => {
  const armazenada = sessionStorage.getItem('unip__mensagem');
  return armazenada ? JSON.parse(armazenada) as mensagem : null;
};
